import { render, staticRenderFns } from "./GeneralReminders.vue?vue&type=template&id=f511f1b4"
import script from "./GeneralReminders.vue?vue&type=script&lang=js"
export * from "./GeneralReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports